import { render, staticRenderFns } from "./HomeNewGuide.vue?vue&type=template&id=63167cb1&scoped=true"
import script from "./HomeNewGuide.vue?vue&type=script&lang=js"
export * from "./HomeNewGuide.vue?vue&type=script&lang=js"
import style0 from "./HomeNewGuide.vue?vue&type=style&index=0&id=63167cb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63167cb1",
  null
  
)

export default component.exports